import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  AlertModule,
  BreadcrumbModule,
  DropdownModule,
  EmptyStateModule,
  IconModule,
  LoaderModule,
  LogoModule,
  ModalModule,
  NavbarModule,
  SidebarModule,
  TableModule
} from '@michelin/theme';
import { MatIconModule } from '@angular/material/icon';

const modules = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  BreadcrumbModule,
  DropdownModule,
  ModalModule,
  SidebarModule,
  NavbarModule,
  LogoModule,
  LoaderModule,
  IconModule,
  TableModule,
  EmptyStateModule,
  TranslateModule,
  MatIconModule,
  AlertModule
];

@NgModule({
  imports: [...modules],
  declarations: [],
  exports: [...modules],
  providers: []
})
export class SharedModule {}
